/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { services } from '../../context';
import { ServicesState } from './servicesTypes';

const initialState: ServicesState = {
  from: new Date().toISOString(),
  prevEnabled: false,
  availableServices: [],
};

export const getServices = createAsyncThunk(
  'services/getServices',
  async (
    {
      zipCode,
      operation,
      stateCode,
    }: {
      zipCode: string;
      operation: string;
      stateCode: string | undefined;
    },
    { rejectWithValue },
  ) => {
    const { result, error } = await services.appointment.getAvailableServices(
      zipCode,
      operation,
      stateCode,
    );

    if (error) {
      return rejectWithValue(error);
    }

    return result.services;
  },
);

const servicesSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    clearAvailableServices(state) {
      state.availableServices = [];
    },
    updateServicesStateFromCache(state, action: PayloadAction<ServicesState>) {
      return action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getServices.fulfilled, (state, action) => {
      state.availableServices = action.payload;
    });
  },
});

export const { clearAvailableServices, updateServicesStateFromCache } =
  servicesSlice.actions;

export default servicesSlice.reducer;
